import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson gründet die London Rubber Company und verkauft importierte Kondome und Zubehör für Herrenfriseure.',
		},
		{
			year: 1929,
			description: 'Die London Rubber Company (LRC) lässt die Marke „Durex“ registrieren',
		},
		{
			year: '1950er',
			description: 'Durex bringt sein erstes befeuchtetes Kondom auf den Markt',
		},
		{
			year: 1953,
			description: 'Durex ist die erste Marke, die ein elektronisches Testverfahren entwickelt und einsetzt',
		},
		{
			year: '1960er',
			description: 'Durex bringt das erste anatomisch geformte Kondom auf den Markt.',
		},
		{
			year: '1970er',
			description: 'Durex ist die weltweit erste Kondommarke, die in vielen Ländern Werbung betreibt',
		},
		{
			year: '1990er',
			description: 'Durex ist die erste Kondommarke, die ein globales „Qualitätssiegel“ als Standard einführt',
		},
		{
			year: 1995,
			description: 'Durex bringt eine Reihe bunter und aromatisierter Kondome auf den Markt',
		},
		{
			year: 1996,
			description: 'Durex ist die erste Kondommarke, die eine Website einrichtet',
		},
		{
			year: 1997,
			description: 'Durex bringt latexfreie Kondome auf den Markt. Für das Produkt wird ein neues, nicht allergieauslösendes Material genutzt: Das von Durex entwickelte synthetische Polyurethan ist weicher und elastischer als Naturkautschuklatex.',
		},
		{
			year: 1998,
			description: 'Durex ist die erste Kondommarke, die eine Umfrage zum weltweiten sexuellen Wohlbefinden durchführt und veröffentlicht',
		},
		{
			year: 2001,
			description: 'Durex bringt Pleasuremax auf den Markt und ist somit die erste Kondommarke, die ein Kondom vermarktet, das zur Stimulation beider Partner sowohl gerippt als auch genoppt ist. ',
		},
		{
			year: 2003,
			description: 'Durex bringt ein aufregendes Sortiment von Play Gleitgelen auf den Markt',
		},
		{
			year: 2005,
			description: 'Durex Network veröffentlicht die Berichte „Face of Global Sex“, die die Aspekte sexuellen Verhaltens erforschen und als Informationsquelle für Akademiker und Entscheidungsträger dienen sollen.',
		},
		{
			year: 2008,
			description: 'Um Safer Sex bei jungen Leuten zu fördern, ermutigt Durex Teens und Twens zwischen 16 und 24 Jahren dazu, ein einzigartiges Poster zur sexuellen Gesundheit zu entwerfen – ein Poster von Jugendlichen für Jugendliche.',
		},
		{
			year: 2009,
			description: 'Durex wird 80!',
		},
		{
			year: 2010,
			description: 'Durex unterstützt die Initiative „Condomize!“ des Bevölkerungsfonds der Vereinten Nationen bei der Welt-AIDS-Konferenz in Wien durch eine Spende von 220.000 Kondomen.',
		},
		{
			year: 2010,
			description: 'Durex wird von Reckitt Benckiser aufgekauft',
		},
		{
			year: 2010,
			description: 'Durex bringt Performax Intense auf den Markt – ein Kondom, das für den gemeinsamen Höhepunkt entwickelt wurde. Dieses Kondom hat eine Innenbeschichtung mit 5% Benzocain und eine stimulierende Struktur, die zu längerem und intensiverem Sex verhelfen soll',
		},
		{
			year: 2019,
			description: 'Durex wird 90!',
		},
	]
}